const e = [
  {
    color: "#007F80",
    value: "< 50",
    ranges: [0, 50],
    visible: !0
  },
  {
    color: "#70A494",
    value: "50 to 70",
    ranges: [50, 70],
    visible: !0
  },
  {
    color: "#B4C8A8",
    value: "70 to 90",
    ranges: [70, 90],
    visible: !0
  },
  {
    color: "#F6EDBD",
    value: "90 to 100",
    ranges: [90, 100],
    visible: !0
  },
  {
    color: "#EDBB8A",
    value: "100 to 150",
    ranges: [100, 150],
    visible: !0
  },
  {
    color: "#DE8A5A",
    value: "150 to 200",
    ranges: [150, 200],
    visible: !0
  },
  {
    color: "#CA562C",
    value: "> 200",
    ranges: [200, 1e5],
    visible: !0
  }
], l = {
  cbsa: {
    visible: !1
  },
  county: {
    visible: !0,
    range: [3, 7]
  },
  zipcode: {
    visible: !1
  },
  cbg: {
    visible: !0,
    range: [7, 12]
  }
};
export {
  e as CRIME_RISK_STATIC_BINS,
  l as CRIME_RISK_ZOOM_DETAILS
};
//# sourceMappingURL=index.es467.js.map
